
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forkliftestimates/contact-us",
      function () {
        return require("private-next-pages/forkliftestimates/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forkliftestimates/contact-us"])
      });
    }
  